<template>
    <div>


        <div v-if="this.person !== null">
            <div class="row">
                <div class="col-sm-2">
                    <back-button></back-button>
                </div>
                <div class="col-sm-8">
                    <h1 class="user-title">{{ person.full_name }}</h1>
                </div>
                <div class="col-sm-2"></div>
            </div>
            <br>

            <div class="row">
                <div class="col-md-12">
                    <single-edit-race-number :person="person"></single-edit-race-number>
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <contact-details :person="person"></contact-details>
                </div>
                <div class="col-md-6">
                    <entry-details :person="person"></entry-details>
                </div>
            </div>

            <hr class="half-width">

            <person-comments :person="person"></person-comments>

        </div>
        <div v-else>
            <p class="text-center">
                <loading-text></loading-text>
            </p>
        </div>
    </div>
</template>

<script>
    import ContactDetails from '../components/Record/ContactDetails.vue';
    import PersonComments from '../components/Record/PersonComments.vue';
    import EntryDetails from "../components/Record/EntryDetails";
    import SingleEditRaceNumber from "../components/Record/SingleEditRaceNumber";
    import BackButton from "../components/Support/BackButton.vue";
    import { mapMutations } from 'vuex';

    export default {
        data() {
            return {
                user_id: 0,
            }
        },

        components: {
            BackButton,
            EntryDetails,
            SingleEditRaceNumber,
            ContactDetails,
            PersonComments,
        },

        computed: {
            person() {
                return this.$store.state.selectedPerson;
            }
        },

        methods: {
            ...mapMutations(['setSelectedPerson']),

            showRecord() {
                this.setSelectedPerson(null);

                this.user_id = this.$route.params.user_id;
                let includes = [
                    'comments',
                    'upcoming_entries.event',
                    'upcoming_entries.status',
                    'upcoming_entries.entry_method',
                    'upcoming_entries.charity',
                    'upcoming_entries.timing_pen',
                    'upcoming_entries.labels',
                ];

                axios.get(`/api/person/${this.user_id}`, {
                    params: { 'include': includes.join(',') }
                })
                    .then(response => {
                        this.setSelectedPerson(response.data);
                    })
                    .catch(error => {
                        HelpdeskAlert.alertError({ 'text': `There was an error fetching user #${this.user_id}.` });
                        this.$router.push({ name: 'records_table' });
                    });
            }
        },

        mounted() {
            this.showRecord();
        },

        watch: {
            '$route'(to, from) {
                this.showRecord();
            }
        }

    }
</script>

<style scoped lang="scss">

    .user-title {
        margin-top: 0;
        text-align: center;
    }
</style>
